export default __webpack_public_path__ + "static/media/image15.e6117378.jpg";